export const EMPTY_STATE_FIELDS = [
    {
        key: 'emptyState.paddingVertical',
        label: '위아래 여백',
        help: '목록·상세 화면에 내용이 없거나 불러오지 못했을 때 보이는 안내 묶음(제목·설명)의 위아래 여백입니다. 여백을 따로 정한 화면(카테고리 선택 등)은 그 값을 따릅니다.',
        group: '빈 상태',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: 80,
        min: 0,
        max: 160,
    },
    {
        key: 'emptyState.gap',
        label: '줄 간격',
        help: '빈 상태 안내의 그림·제목·설명 사이 간격입니다.',
        group: '빈 상태',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.xs',
        min: 0,
        max: 32,
    },
    {
        key: 'emptyState.titleSize',
        label: '제목 글자 크기',
        help: '빈 상태 안내 첫 줄(예: "내역이 없습니다")의 글자 크기입니다. 크기를 따로 정한 화면(홈 섹션)은 그 값을 따릅니다.',
        group: '빈 상태',
        type: 'size',
        tokenGroup: 'fontSize',
        defaultValue: '$fontSize.xs',
        min: 8,
        max: 24,
    },
    {
        key: 'emptyState.subtitleSize',
        label: '설명 글자 크기',
        help: '빈 상태 안내 둘째 줄(예: "당겨서 다시 시도해 주세요")의 글자 크기입니다.',
        group: '빈 상태',
        type: 'size',
        tokenGroup: 'fontSize',
        defaultValue: '$fontSize.xs',
        min: 8,
        max: 24,
    },
    {
        key: 'emptyState.home.iconSize',
        label: '홈 섹션 빈 상태 아이콘 크기',
        help: '홈 화면 섹션에 보여 줄 항목이 없을 때 안내 글 위에 그리는 메모 아이콘의 크기입니다(라이브 목록처럼 한 줄로만 보이는 섹션은 아이콘이 없습니다).',
        group: '홈 섹션',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: '$dimension.s',
        min: 12,
        max: 64,
    },
    {
        key: 'emptyState.home.titleSize',
        label: '홈 섹션 빈 상태 글자 크기',
        help: '홈 화면 섹션에 보여 줄 항목이 없을 때의 안내 글 크기입니다.',
        group: '홈 섹션',
        type: 'size',
        tokenGroup: 'fontSize',
        defaultValue: '$fontSize.xs-plus',
        min: 8,
        max: 24,
    },
    {
        key: 'emptyState.home.compactPaddingVertical',
        label: '홈 섹션 한 줄 빈 상태 위아래 여백',
        help: '라이브 목록처럼 빈 상태를 아이콘 없이 한 줄로 보여 주는 홈 섹션의 안내 글 위아래 여백입니다.',
        group: '홈 섹션',
        type: 'size',
        tokenGroup: 'spacing',
        defaultValue: '$spacing.l-plus',
        min: 0,
        max: 64,
    },
];
//# sourceMappingURL=emptyState.js.map